module.exports = "./img/d82f3abce8e2e82970a69eb39010e461.jpg";